import {
  PURGE_FITRAH,
  UPDATE_TOTAL,
  UPDATE_ZAKAT_DATA,
  UPDATE_ZAKAT_FITRAH_DATA,
  ZAKAT_PURGE,
  UPDATE_SOURCE_OF_INCOME
} from "../constants";

const zakatDefaultState = () => ({
  savings: { name: "Savings", amount: 0.0 },
  gold: { name: "Gold", amount: 0.0 },
  insurance: { name: "Insurance", amount: 0.0 },
  business: { name: "Business", type: 'Trade', amount: 0.0 },
  zakatfitrah: { 
    name: "Zakat Fitrah", 
    type: {
      normal: { rate: null, noOfPerson: 0, amount: 0.00 },
      premium: { rate: null, noOfPerson: 0, amount: 0.00 },
      variable: { rate: null, noOfPerson: 0, amount: 0.00 },
    },
    amount: 0.0 
  },
  shares: { name: "Shares", amount: 0.0 },
  sourceOfIncome: null,
  totalAmount: 0,
});

export default function zakatReducer(state = zakatDefaultState(), action) {

    switch(action.type) {
        case UPDATE_ZAKAT_DATA:
            return { ...state , ...action.zakat };
        case ZAKAT_PURGE:
            return zakatDefaultState();
        case UPDATE_SOURCE_OF_INCOME:
            return { ...state, ...{ sourceOfIncome: action.source } }
        case UPDATE_TOTAL:
            return { ...state, ...{ totalAmount: action.total} }
        case PURGE_FITRAH:
            return { ...state, ...{ zakatfitrah: zakatDefaultState().zakatfitrah} }
        case UPDATE_ZAKAT_FITRAH_DATA: {
          const { fitrahType, data } = action.payload;

          const currentData = state;
          const currentTotal = state.zakatfitrah.amount;
    
          // Update specific fitrah type
          currentData.zakatfitrah.type[fitrahType] = data

          const fitrahTotal = Number(parseFloat(
            Number(currentData.zakatfitrah.type.normal.amount) + 
            Number(currentData.zakatfitrah.type.premium.amount) +
            Number(currentData.zakatfitrah.type.variable.amount)
          ).toFixed(2));
            
          currentData.zakatfitrah.amount = fitrahTotal?.toFixed(2);

          let zakatTotal = Number(currentData.totalAmount);

          // Update total amount
          zakatTotal = zakatTotal - Number(currentTotal > 0 ? currentTotal : 0);

          return { ...state, totalAmount: zakatTotal + fitrahTotal?.toFixed(2) };
        }

        default:
            return state;
    }
}